import en from "./en.json";
import es from "./es.json";
import fr from "./fr.json";

type DesignSystemLocale = "en" | "fr" | "es";

const resources = {
    "en": en,
    "es": es,
    "fr": fr
};

function getText(local: DesignSystemLocale, vocabKey: string): string {
    const resource = resources[local];

    if (!resource)
        throw new Error(`Unable to get resources for local=${local}`);

    return resource[vocabKey] ?? vocabKey?.toUpperCase();
}

export { DesignSystemLocale, getText };
